// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require('./notifications')
require('./services')
require('./service_show')
require('../profile_survey')

document.addEventListener("DOMContentLoaded", (e) => {
    let close_popular = document.getElementById('js-close-popular');

    if(close_popular){
        close_popular.addEventListener('click', (e) => {
            document.cookie = 'close_popular=true; expires=Sun, 1 Jan 2030 00:00:00 UTC; path=/';
            document.getElementById('popular-services').remove();
        });
    }
});

// Mobile menu is no longer used since sidebar is always visible
// Keeping event listeners in case they're needed later

document.addEventListener("DOMContentLoaded", (e) => {
  toggles = document.querySelectorAll('.js-toggle-button');

  toggles.forEach((toggle) => {
    toggle.addEventListener('click', (e) => {
      let target = e.target;
      let target_span = target.children[0];

      if(target.classList.contains('bg-gray-400')){ //disabled -> enabled
        target.classList.remove('bg-gray-400');
        target.classList.add('bg-blue-600');
        target_span.classList.remove('translate-x-0');
        target_span.classList.add('translate-x-5');

        setCookie('show_only_impacting', 'true', 365);
        toggleOnlyImpacting(true);
      } else { //enabled -> disabled
        target.classList.remove('bg-blue-600');
        target.classList.add('bg-gray-400');
        target_span.classList.remove('translate-x-5');
        target_span.classList.add('translate-x-0');

        setCookie('show_only_impacting', 'true', -1);
        toggleOnlyImpacting(false);

      }
    })
  });
});

function toggleOnlyImpacting(result){
  let outages = [].slice.call(document.getElementById('ongoing-outages').children);
  outages.forEach((child) => {
    if(result){
      if(!child.classList.contains('js-impact')){
        child.classList.add('hidden');
      }
    } else {
      child.classList.remove('hidden');
    }
  });
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// Sidebar dropdown functionality
document.addEventListener('DOMContentLoaded', function() {
  // Dropdown configuration
  const dropdowns = [
    {
      triggerId: 'profile-select',
      dropdownId: 'profile-options',
      width: '256px',
      positionType: 'top', // positions from top
      customHandlers: function(dropdown) {
        // Handle profile option clicks
        dropdown.querySelectorAll('.profile-option').forEach(option => {
          option.addEventListener('click', function() {
            window.location = this.dataset.value;
            updateProfileTooltip();
          });
        });
      }
    },
    {
      triggerId: 'monitors-select',
      dropdownId: 'monitors-options',
      width: '260px',
      positionType: 'top'
    },
    {
      triggerId: 'account-select',
      dropdownId: 'account-options',
      width: '256px',
      positionType: 'bottom' // positions from bottom
    }
  ];

  // Helper function to close all dropdowns except the specified one
  function closeOtherDropdowns(exceptId) {
    dropdowns.forEach(config => {
      if (config.dropdownId !== exceptId) {
        const dropdown = document.getElementById(config.dropdownId);
        if (dropdown) dropdown.classList.add('hidden');
      }
    });
  }

  // Initialize each dropdown
  dropdowns.forEach(config => {
    const trigger = document.getElementById(config.triggerId);
    const dropdown = document.getElementById(config.dropdownId);
    
    if (!trigger || !dropdown) return;
    
    let hoverTimeout;
    
    // Show dropdown on hover
    trigger.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimeout);
      closeOtherDropdowns(config.dropdownId);
      
      const rect = trigger.getBoundingClientRect();
      
      // Position dropdown
      dropdown.style.left = (rect.right + 8) + 'px';
      dropdown.style.width = config.width;
      
      if (config.positionType === 'bottom') {
        dropdown.style.bottom = (window.innerHeight - rect.bottom) + 'px';
        dropdown.style.top = 'auto';
      } else {
        dropdown.style.top = rect.top + 'px';
        dropdown.style.bottom = 'auto';
        
        // Set max height for top-positioned dropdowns
        if (config.triggerId === 'profile-select') {
          const viewportHeight = window.innerHeight;
          const spaceBelow = viewportHeight - rect.top - 20;
          dropdown.style.maxHeight = Math.min(400, spaceBelow) + 'px';
          dropdown.style.overflowY = 'auto';
        }
      }
      
      dropdown.classList.remove('hidden');
    });
    
    // Keep dropdown open when hovering over it
    dropdown.addEventListener('mouseenter', function() {
      clearTimeout(hoverTimeout);
    });
    
    // Hide on mouse leave with delay
    const hideDropdown = function() {
      hoverTimeout = setTimeout(function() {
        dropdown.classList.add('hidden');
      }, 300);
    };
    
    trigger.addEventListener('mouseleave', hideDropdown);
    dropdown.addEventListener('mouseleave', hideDropdown);
    
    // Apply custom handlers if specified
    if (config.customHandlers) {
      config.customHandlers(dropdown);
    }
  });
  
  // Global click handler to close dropdowns when clicking outside
  document.addEventListener('click', function(event) {
    dropdowns.forEach(config => {
      const trigger = document.getElementById(config.triggerId);
      const dropdown = document.getElementById(config.dropdownId);
      if (trigger && dropdown && !trigger.contains(event.target) && !dropdown.contains(event.target)) {
        dropdown.classList.add('hidden');
      }
    });
  });

  
  // Initialize other components
  initializeNoticeDismiss();
  initializeSidebarToggle();
});

// Notice dismiss functionality
function initializeNoticeDismiss() {
  const dismissLink = document.getElementById('dismiss-feedback');
  if (!dismissLink) return;
  
  dismissLink.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    fetch(dismissLink.dataset.href, {
      method: 'DELETE',
      headers: {
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      credentials: 'same-origin'
    }).then(() => {
      const notices = document.getElementById('notices');
      if (notices) notices.remove();
    });
  });
}

// Sidebar collapse functionality
function initializeSidebarToggle() {
  const toggleBtns = ['js-toggle-sidebar', 'js-toggle-sidebar-collapsed'];
  const sidebar = document.getElementById('js-sidebar-menu');
  const mainContent = document.getElementById('main-content');
  
  if (!sidebar || !mainContent) return;
  
  // Add transitions after page load to prevent initial animation
  setTimeout(function() {
    sidebar.classList.add('transition-all', 'duration-300');
    mainContent.classList.add('transition-all', 'duration-300');
  }, 100);
  
  function toggleSidebar() {
    // Only allow toggle on desktop
    if (window.innerWidth < 1024) return;
    
    const isCollapsed = sidebar.classList.contains('sidebar-collapsed');
    const newState = !isCollapsed;
    
    // Toggle classes
    sidebar.classList.toggle('sidebar-collapsed', newState);
    mainContent.classList.toggle('lg:pl-16', newState);
    mainContent.classList.toggle('lg:pl-64', !newState);
    
    // Persist state
    const stateValue = newState ? 'true' : 'false';
    localStorage.setItem('sidebarCollapsed', stateValue);
    document.cookie = `sidebarCollapsed=${stateValue}; path=/; max-age=31536000`;
  }
  
  // Attach event listeners to both toggle buttons
  toggleBtns.forEach(btnId => {
    const btn = document.getElementById(btnId);
    if (btn) {
      btn.addEventListener('click', toggleSidebar);
    }
  });
}

// Helper function to update profile tooltip (no longer used but kept for compatibility)
function updateProfileTooltip() {
  // Tooltips have been removed from the UI
}

